import { render, staticRenderFns } from "./HorizontalBarChart.vue?vue&type=template&id=4bed666c&scoped=true&"
import script from "./HorizontalBarChart.vue?vue&type=script&lang=ts&"
export * from "./HorizontalBarChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bed666c",
  null
  
)

export default component.exports